import LinkButton, {LinkButtonProps} from 'components/LinkButton';
import {FC} from 'react';

import {useNavigationContext} from '..';
import {button} from './styles.module.css';

type BaseNavigationTabsButtonProps = {
    label: string;
    name: string;
} & LinkButtonProps;

const BaseNavigationTabsButton: FC<BaseNavigationTabsButtonProps> = ({
    disabled,
    label,
    name,
    ...rest
}) => {
    const {selection} = useNavigationContext();

    return (
        <LinkButton
            aria-label={`tab-navigation-${label.toLowerCase()}`}
            aria-selected={selection === name}
            className={button}
            disabled={disabled}
            kind="custom"
            {...rest}
        >
            {label}
        </LinkButton>
    );
};
export default BaseNavigationTabsButton;
